import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

export const FooterBackToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            const gallerySection = document.getElementById('OurGallerysec');
            if (gallerySection) {
                const rect = gallerySection.getBoundingClientRect();
                const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
                setIsVisible(!isVisible);
            } else {
                setIsVisible(true);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div id="bakctTotop" className={isVisible ? 'show' : ''} onClick={scrollToTop}>
            <FontAwesomeIcon icon={faArrowUp} />
            <h2><span>B</span><span>a</span><span>c</span><span>k</span> <span>t</span><span>o </span><span>t</span><span>o</span><span>p</span></h2>
        </div>
    );
};
